<template>
  <div class="w-full flex bg-white border-round height-100">
    <div class="flex items-center w-full">
      <div class="w-4/12 p-16">
        <h1 class="text-3xl mb-0 text-dark font-semibold">Brand Profile</h1>
        <p class="fsize14 text-gray mb-0">Setup your brand fonts</p>
        <div class="shadow-lg border-round mt-8 px-8 pt-8 pb-32 relative">
          <div>
            <small class="text-sm text-primary font-semibold">Step 2</small>
            <h1 class="fsize21 col-4f mb-0 font-semibold">Brand Fonts</h1>

            <p class="fsize14 col-4f mb-0">Pick a font pallate of your brand</p>
          </div>

          <div class="mt-4">
            <div class="relative">
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Primary Font <span class="text-danger">*</span></small
                >
              </div>
              <el-select
                v-model="primaryFont"
                placeholder="Primary Font"
                class="w-full mt-2"
                filterable
              >
                <el-option
                  v-for="item in googleFont"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ primaryFont === "" ? "This Field is required" : "" }}
              </p>
            </div>
            <div class="relative mt-4">
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Secondary Font <span class="text-danger">*</span></small
                >
              </div>
              <el-select
                v-model="secondaryFont"
                placeholder="Secondary Font"
                class="w-full mt-2"
                filterable
              >
                <el-option
                  v-for="item in googleFont"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ secondaryFont === "" ? "This Field is required" : "" }}
              </p>
            </div>
            <div class="mt-6">
              <p class="fsize14 col-838383 mb-0">
                Explore hundreds of fonts available on Google fonts of your
                project.
              </p>
            </div>
          </div>
          <div
            class="absolute bottom-0 margin-niche right-0 left-0 w-full flex justify-between"
          >
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/Default.svg"
                class="mar-left"
                @click="handleClick('business')"
              />
            </div>
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class="mar-right"
                @click="handleClick('color')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="w-8/12 bg-primary p-16 h-full relative">
        <div class="px-10 pt-10 pb-32 z-50 border-round bg-white">
          <div class="block pt-1">
            <small class="text-lg text-primary font-semibold">Presets</small>
            <h1 class="text-xl text-dark mb-0 font-semibold">
              Try these tried & tested fonts pairing
            </h1>
            <div class="mt-6">
              <swiper
                :options="swiperOption"
                class="swip-jumppx2 related-product-swiper"
              >
                <!-- <swiper-slide
                  v-for="item in related_items"
                  :key="item.objectId"
                  class="my-3 cursor-pointer"
                > -->
                <!-- Item Image -->
                <!-- <div class="bg-white cust-shadow border-box border-round p-4">
                    <small>{{ item.head }}</small>
                    <h1 class="text-dark fsize21 font-semibold">
                      {{ item.heads }}
                    </h1>
                    <small>{{ item.para }}</small>
                    <h1 class="text-dark text-lg font-medium">
                      {{ item.robo }}
                    </h1>
                  </div>
                </swiper-slide> -->

                <swiper-slide
                  class="my-3 cursor-pointer"
                  v-for="(font, index) in fontCardFamily"
                  :key="index"
                >
                  <!-- Item Image -->
                  <div
                    class="bg-white cust-shadow border-box border-round p-4"
                    @click="DataSelect(font)"
                  >
                    <small>{{ font.name }}</small>
                    <h1 class="text-dark fsize21 font-semibold">
                      {{ font.SerifFont }}
                    </h1>
                    <small>Paragraph</small>
                    <h1 class="text-dark text-lg font-medium">
                      {{ font.SansSerif }}
                    </h1>
                  </div>
                </swiper-slide>

                <!-- <div
                  class="swiper-button-prev cust-hidden"
                  slot="button-prev"
                ></div>
                <div
                  class="swiper-button-next cust-hidden"
                  slot="button-next"
                ></div> -->
              </swiper>
            </div>
          </div>
          <!-- <div class="mt-32 flex w-full">
<<<<<<< HEAD
          <div class="mt-32 flex w-full">
=======
<<<<<<< HEAD
           <div class="mt-32 flex w-full">
=======
          <div class="mt-32 flex w-full">
>>>>>>> 50a6e58c7b71842b5e48558131c646ee01a1361a
>>>>>>> 697757ba507b18a0e956c172d34a1feeaea2bcd0
            <div class="w-3/12 p-2">
              <div>
                <p class="fsize20 font-semibold col-4f mb-0 cross">Preview</p>
              </div>
            </div>
            <div class="w-9/12 p-4">
              <h1 class="text-4xl mb-0 col-4f font-semibold">
                This is a Heading
              </h1>
              <p class="fsize16 col-4f mb-0">
                Finally this is an example of how<br />
                your paragraphs will look like with<br />
                this your design preferences:)
              </p>
            </div>
          </div> -->
          <div class="w-full">
            <iframe :srcdoc="html" class="w-full new-zee"> </iframe>
          </div>
        </div>
        <div class="absolute top-0 left-0">
          <div class="grid grid-cols-1 gap-4">
            <marquee
              class="bg-transparent text-white font-semibold mb-0"
              scrollamount="20"
            >
              <div class="grid grid-cols-1 gap-5">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name2.png"
                  class="w-full height-marf"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name2.png"
                  class="w-full height-marf"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name2.png"
                  class="w-full height-marf"
                />
              </div>
            </marquee>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      fontCardSelect: "",
      primaryFont: "",
      secondaryFont: "",
      html: "",
      submitted: false,
      swiperOption: {
        slidesPerView: 3.5,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      related_items: [
        {
          name: "Template 1",
          head: "Heading",
          heads: "Opan Sans",
          para: "paragraph",
          robo: "Roboto",
        },
        {
          name: "Template 2",
          head: "Heading",
          heads: "Opan Sans",
          para: "paragraph",
          robo: "Roboto",
        },
        {
          name: "Template 3",
          head: "Heading",
          heads: "Opan Sans",
          para: "paragraph",
          robo: "Roboto",
        },
        {
          name: "Template 4",
          head: "Heading",
          heads: "Opan Sans",
          para: "paragraph",
          robo: "Roboto",
        },
        {
          name: "Template 5",
          head: "Heading",
          heads: "Opan Sans",
          para: "paragraph",
          robo: "Roboto",
        },
        {
          name: "Template 6",
          head: "Heading",
          heads: "Opan Sans",
          para: "paragraph",
          robo: "Roboto",
        },
      ],
      products: [],
      fontCardFamily: [
        {
          name: "Serif & Sans-Serif",
          SerifFont: "PlayFair",
          SansSerif: "Lato",
        },
        {
          name: "Classic Combination",
          SerifFont: "Georgia",
          SansSerif: "Arial",
        },
        {
          name: "Modern & Clean",
          SerifFont: "Montserrat",
          SansSerif: "Open Sans",
        },
        {
          name: "Elegant & Stylish",
          SerifFont: "Cormorant Garamond",
          SansSerif: "Raleway",
        },
        {
          name: "Friendly & Playful",
          SerifFont: "Poppins",
          SansSerif: "Pacifico",
        },
        {
          name: "Professional & Readable",
          SerifFont: "Roboto",
          SansSerif: "Nunito",
        },
        {
          name: "Minimalist & Modern",
          SerifFont: "Avenir",
          SansSerif: "Helvetica Neue",
        },
        {
          name: "Artistic & Creative",
          SerifFont: "Abril Fatface",
          SansSerif: "Quicksand",
        },
        {
          name: "High Contrast & Bold",
          SerifFont: "Bodoni",
          SansSerif: "Futura",
        },
        {
          name: "Goemetric & Futuristic",
          SerifFont: "Bebas Neue",
          SansSerif: "Raleway",
        },
      ],
    };
  },
  computed: {
    ...mapState("brandProfile", {
      googleFont: "googleFontFamily",
      brandProfile: "brandProfile",
    }),
    ...mapState("user", { selectedProject: "selectedProject" }),
  },
  watch: {
    primaryFont() {
      this.iframeTemplate();
    },
    fontCardSelect(value) {
      if (value) {
        this.primaryFont = value.SansSerif;
        this.secondaryFont = value.SerifFont;
      }
    },
    secondaryFont() {
      this.iframeTemplate();
    },
  },
  async mounted() {
    this.completed = this.brandProfile.isCompleted;
    if (
      this.brandProfile.hasOwnProperty("primaryFont") &&
      this.brandProfile.hasOwnProperty("secondaryFont")
    ) {
      this.primaryFont = this.brandProfile.primaryFont;
      this.secondaryFont = this.brandProfile.secondaryFont;
    }
    this.iframeTemplate();
    this.IScompleted();
  },
  methods: {
    IScompleted() {
      if (this.completed === true) {
        this.$router.push({ name: "dashboard" });
      }
    },
    DataSelect(value) {
      this.fontCardSelect = value;
    },
    iframeTemplate() {
      this.html = `
        <!DOCTYPE html>
        <html>
        <head>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=${this.primaryFont}|${this.secondaryFont}">
        </head>
        <body>
          <div class="mt-32 flex w-full">
            <div class="w-3/12 p-2">
                <div>
                  <p class="fsize20 font-semibold col-4f mb-0 cross">Preview</p>
                </div>
              </div>
              <div class="w-9/12 p-4">
                <h1  style="font-family:${this.primaryFont};" class="text-4xl mb-0 col-4f font-semibold">
                  This is a Heading
                </h1>
                <p style="font-family:${this.secondaryFont};"  class="fsize16 col-4f mb-0">
                    Finally this is an example of how<br />
                    your paragraphs will look like with<br />
                    this your design preferences:)
                </p>
              </div>
            </div>
          </div>
        </body>
        </html>`;
    },
    async handleClick(name) {
      this.submitted = true;
      let payloadFont = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        primaryFont: this.primaryFont,
        secondaryFont: this.secondaryFont,
      };

      if (
        !(
          this.primaryFont === this.brandProfile.primaryFont &&
          this.secondaryFont === this.brandProfile.secondaryFont
        )
      ) {
        let data = await this.$store.dispatch(
          "brandProfile/uploadBrandProfile",
          payloadFont
        );
        let payloadBrand = {
          projectId: this.selectedProject._id,
          projectName: this.selectedProject.projectName,
        };
        await this.$store.dispatch(
          "brandProfile/getBrandProfile",
          payloadBrand
        );
        console.log(data);
      }
      if (this.primaryFont !== "" && this.secondaryFont !== "") {
        this.$router.push({ name: name });
      }
    },
  },
};
</script>
<style>
.new-zee {
  z-index: 999999 !important;
  position: relative;
}
</style>
